/*
  ============================================================
  favoritos.js — Lista de favoritos (localStorage)
  ============================================================

  O QUE FAZ:
  Gerencia a lista de produtos favoritados pelo visitante, salva no
  localStorage do navegador (não sincroniza entre dispositivos nem
  precisa de conta de cliente — é por navegador/aparelho).

  - Qualquer botão com [data-favorite-toggle] (ex: coração no
    card-product) adiciona/remove o produto da lista, usando os
    data-attributes do próprio botão (id, handle, title, price,
    image, url) — não faz nenhuma chamada de rede.
  - Atualiza o contador no ícone do cabeçalho ([data-favorites-count]).
  - Preenche a gaveta lateral (#favoritos-drawer, snippets/favoritos.liquid)
    quando ela é aberta, com um botão de remover por item.

  OBSERVAÇÕES:
  Se o localStorage não estiver disponível (aba privada bloqueando,
  navegador antigo), o script falha em silêncio: o coração some de
  responder mas o resto do site continua funcionando normalmente.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'casaDosOculosFavoritos';

  function readFavorites() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeFavorites(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // localStorage indisponível (aba privada etc.) — segue sem persistir.
    }
  }

  function isFavorited(list, id) {
    return list.some(function (item) { return item.id === id; });
  }

  function updateCount() {
    var count = readFavorites().length;
    document.querySelectorAll('[data-favorites-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function syncButtons() {
    var list = readFavorites();
    document.querySelectorAll('[data-favorite-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('is-active', isFavorited(list, id));
    });
  }

  function toggleFavorite(btn) {
    var id = btn.getAttribute('data-product-id');
    var list = readFavorites();
    if (isFavorited(list, id)) {
      list = list.filter(function (item) { return item.id !== id; });
    } else {
      list.push({
        id: id,
        handle: btn.getAttribute('data-product-handle'),
        title: btn.getAttribute('data-product-title'),
        price: btn.getAttribute('data-product-price'),
        image: btn.getAttribute('data-product-image'),
        url: btn.getAttribute('data-product-url')
      });
    }
    writeFavorites(list);
    syncButtons();
    updateCount();
    renderDrawer();
  }

  function renderDrawer() {
    var container = document.querySelector('[data-favoritos-list]');
    if (!container) return;
    var list = readFavorites();
    if (!list.length) {
      container.innerHTML = '<p class="favoritos-drawer__empty">Você ainda não tem favoritos.</p>';
      return;
    }
    container.innerHTML = list.map(function (item) {
      return (
        '<div class="favoritos-item">' +
          '<a href="' + item.url + '" class="favoritos-item__media">' +
            (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<div class="favoritos-item__info">' +
            '<a href="' + item.url + '" class="favoritos-item__title">' + item.title + '</a>' +
            '<span class="favoritos-item__price">' + item.price + '</span>' +
          '</div>' +
          '<button type="button" class="favoritos-item__remove" data-favoritos-remove="' + item.id + '" aria-label="Remover dos favoritos">&times;</button>' +
        '</div>'
      );
    }).join('');
  }

  function openDrawer() {
    var drawer = document.getElementById('favoritos-drawer');
    if (!drawer) return;
    renderDrawer();
    drawer.hidden = false;
  }

  function closeDrawer() {
    var drawer = document.getElementById('favoritos-drawer');
    if (drawer) drawer.hidden = true;
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-favorite-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      toggleFavorite(toggleBtn);
      return;
    }
    var openBtn = e.target.closest('[data-favoritos-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-favoritos-close]')) {
      closeDrawer();
      return;
    }
    var removeBtn = e.target.closest('[data-favoritos-remove]');
    if (removeBtn) {
      var id = removeBtn.getAttribute('data-favoritos-remove');
      var list = readFavorites().filter(function (item) { return item.id !== id; });
      writeFavorites(list);
      syncButtons();
      updateCount();
      renderDrawer();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncButtons();
    updateCount();
  });
})();
